export default process.env.VUE_APP_CAPTCHA_SITE_KEY;
